const invoiceStatuses = {
  draft: { id: 'draft', name: 'Draft' },
  open: { id: 'open', name: 'Open' },
  paid: { id: 'paid', name: 'Paid' },
};

export default invoiceStatuses;
